<!-- 了解更多 -->
<template>
  <div style="height: 100%; background: #253746;">
    <Header></Header>
    <div class="knowmore">
      <p class="fb tl f16 pt20 mL20" style="width: 95%">多了解你一些</p>
      <div style="width: 100%;margin:85px auto" v-for="(item, index) in questions" :key="index" v-show="item.show">
        <p class="f16 fb mL20">{{item.name}}：</p>
        <div class="f14 pL10 qDiv mL20 mr20" :class="item.multi ? 'multiDiv' : 'simpleDiv'">{{item.ques}}</div>
        <div class="btns" v-if="item.options.length !== 0">
          <el-tooltip v-for="(item1, index) in item.options"
                      :key='index'
                      placement='bottom' effect='light'
                      :disabled="item.tooltip[index] === ''" :content=item.tooltip[index]>
            <el-button
              class="base-bg base-border-color co-f"
              :class="getBtnClass(item.optionLength, index)"
              @click="selected(item, item1)"
            >
              {{item1}}
            </el-button>
          </el-tooltip>
        </div>
        <div class="ques5" v-else>我想在 <el-input v-model="year"></el-input>年后，存够 <el-input v-model="money"></el-input>元</div>
        <div v-if="item.name === '问题五'" class="tr" style="width:90%;margin: 20px auto;">
          <el-button class="co-f mt20 base-bg base-border-color" style="height: 30px;line-height: 0;" @click="toResult">下一步</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
export default {
  name: 'Home',
  data () {
    return {
      year: 0,
      money: 0,
      account: '',
      password: '',
      beforeTax: '',
      spending: '',
      questions: [
        { name: '问题一',
          ques: '您认为您对于投资的偏好是什么？',
          options: ['保守', '中性', '激进'],
          tooltip: ['', '', ''],
          show: true, multi: false, optionLength: 3 ,key: 'ANSWER1'},
        { name: '问题二',
          ques: '您的投资经验有多少年？',
          options: ['1-3年', '5-10年', '10年以上'],
          tooltip: ['', '', ''],
          show: false, multi: false, optionLength: 3, key: 'ANSWER2' },
        {
          name: '问题三',
          ques: '您那有一个投资产品100%可以获得3%的收益，另外一个产品50%可能性-5%收益，50%可能性+15%收益，您选择哪一个？',
          options: ['第一个投资产品', '第二个投资产品'],
          tooltip: ['', ''],
          show: false,
          multi: true,
          optionLength: 2,
          key: 'ANSWER3',
        },
        { name: '问题四',
          ques: '您需要的退休生活水平是怎么样的？',
          options: ['基础', '舒适', '富足', '奢侈'],
          tooltip: [
            '期望退休后养老金达到约55%的退休前工资水平',
            '期望退休后养老金达到约70%的退休前工资水平',
            '期望退休后养老金达到约90%的退休前工资水平',
            '期望退休后养老金达到约110%的退休前工资水平'],
          show: false, multi: false, optionLength: 4 ,key: 'ANSWER4'},
        { name: '问题五',
          ques: '您想在X年后，存够多少钱？',
          options: [],
          tooltip: [],
          show: false, multi: false, optionLength: 0, key: 'ANSWER5'},
      ],
      selectedOptions : {}
    }
  },
  components: { Header },
  mounted () {
    if (!this.$route.params ||
      !this.$route.params.age ||
      !this.$route.params.alreadyScaleSaving ||
      !this.$route.params.estimatedExpenses ||
      !this.$route.params.preTaxIncome ||
      !this.$route.params.otherIncome ||
      !this.$route.params.gender) {
      this.$router.push({name: 'KnowYou'})
    }
  },
  methods: {
    getBtnClass (length, index) {
      if (length === 2) {
        if (index !== 1) {
          return "two-button"
        } else {
          return "two-button-tail"
        }
      } else if (length === 3) {
        if (index !== 2) {
          return "third-button"
        } else {
          return "third-button-tail"
        }
      } else {
        if (index !== 3) {
          return "fourth-button"
        } else {
          return "fourth-button-tail"
        }
      }
    },
    toResult () {
      const baseInfo = {
        'age': this.$route.params.age,
        'gender': this.$route.params.gender,
        'alreadyScaleSaving': this.$route.params.alreadyScaleSaving,
        'preTaxIncome': this.$route.params.preTaxIncome,
        'otherIncome': this.$route.params.otherIncome,
        'estimatedExpenses': this.$route.params.estimatedExpenses,
        'answerMoney': this.money,
        'answerYear': this.year,
        ...this.selectedOptions
      }
      this.$router.push({name: 'ResultNew', params:baseInfo})
    },
    selected (item, option) {
      this.selectedOptions[item.key] = option
      for (let key in this.questions) {
        if (this.questions[key].name === item.name){
          item.show = false
          this.questions[Number(key)+1]['show'] = true
        }
      }
    }
   }
}
</script>

<style scoped>
.knowmore{
   width: 80%;
   height: 530px;
   border-radius: 20px;
   background: #fff;
   margin: 80px auto;
}
.knowmore .qDiv{
  width: 90%;
  height: 120px;
  border-radius: 15px;
  border: 1px solid rgba(187,187,187);
  margin-top: 37px;
}
.simpleDiv{
  line-height: 30px;
}
.multiDiv{
  line-height: 38px;
}
.knowmore .btns{
  width: 95%;
  height: 30px;
  margin-top: 37px;
  margin-left: 20px;
}
.btns .el-button{
  margin-left: 0;
  height: 30px;
  line-height: 0;
}
.two-button{
  width: 45%;
  margin-right: 5%;
}
.two-button-tail{
  width: 45%;
  margin-right: 5%;
  float: right;
}
.third-button{
  width: 30%;
  margin-right: 3%;
}
.third-button-tail{
  width: 30%;
  margin-right: 3%;
  float: right;
}
.fourth-button{
  width: 22%;
  margin-right: 3%;
}
.fourth-button-tail{
  width: 22%;
  margin-right: 3%;
  float: right;
}
.ques5{
  margin-top: 37px;
  margin-left: 20px;
}
.ques5 .el-input{
  width: 25%;
  height: 30px;
  margin: 0 3%;
}
.el-input >>> .el-input__inner{
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/KnowMore.vue